import React from 'react'
import { connect } from 'react-redux';

import get from 'lodash.get';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete'

import GeolocationService from "../../../../services/geolocationService";

import initPlacesAutocomplete from './addressAutocompleteInitter';
import { getSearchString } from '../formBuilderAnswersHelper';

import { geocodingKeys, addresFields, GOOGLE_MAPS_STARTING_SEARCH_RADIUS } from '../../../../constants/formbuilder';

class AddressAutocomplete extends React.Component {
    handleChange = (address) => {
        this.props.onChange({
            ...this.props.value,
            searchString: address,
        });
    }

    state = {
        searchOptions: {
        },
        inited: false
    }

    componentDidUpdate() {
        if (this.props.gmapsLoaded && !this.state.inited) {
            this.initMap();
        }
    }

    initGooglePlacesSearchOptions = (lat, lng) => {
        this.setState({
            searchOptions: {
                radius: GOOGLE_MAPS_STARTING_SEARCH_RADIUS,
                location: new window.google.maps.LatLng(lat, lng)
            }
        })
    }

    onBlur = () => {
        const selectedSearchString = getSearchString(this.props.value);

        if (selectedSearchString !== get(this.props, 'value.searchString')) {
            this.props.onChange({
                ...this.props.value,
                searchString: selectedSearchString,
            });
        }
    }

    findLatLonFromIP = () => {
        GeolocationService.findLatLonFromIP().then((response) => {
            if (response) {
                var lat = response.data.location.lat;
                var lng = response.data.location.lng;
                this.initGooglePlacesSearchOptions(lat, lng);
            }
        })
    }

    initMap = () => {
        if (navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                this.initGooglePlacesSearchOptions(lat, lng);
            }, () => {
                this.findLatLonFromIP();
            });
        }
        this.setState({
            inited: true
        })
    }

    getAddressInfo(geocodeModel, address) {
        const addressInfo = {
            searchString: address
        };

        if (!geocodeModel) {
            return addressInfo;
        }

        Object.keys(addresFields).forEach(field => {
            const gecodingKey = geocodingKeys[field];
            const fieldPath = addresFields[field];
            let geocodeValue = geocodeModel[gecodingKey];

            if (fieldPath === addresFields.STREET && geocodeModel[geocodingKeys.STREET_NUMBER]) {
                const subpremise = geocodeModel[geocodingKeys.SUBPREMISE]
                    ? `${geocodeModel[geocodingKeys.SUBPREMISE]}/`
                    : '';
                geocodeValue = `${subpremise}${geocodeModel[geocodingKeys.STREET_NUMBER]} ${geocodeValue}`;
            }
            addressInfo[fieldPath] = geocodeValue;
        });

        return addressInfo;
    }

    handleSelect = (address) => {
        geocodeByAddress(address)
            .then(results => {
                const geocodeModel = {};
                results[0].address_components.forEach(item => {
                    geocodeModel[item.types.join(' ')] = item.long_name;
                });
                const addressInfo = this.getAddressInfo(geocodeModel, address);
                this.props.onChange(addressInfo);
            });
    }

    render() {
        const searchString = get(this.props, 'value.searchString') || '';

        return (
            <div>
                {
                    this.props.gmapsLoaded &&
                    <PlacesAutocomplete
                        value={searchString}
                        onChange={this.handleChange}
                        onSelect={this.handleSelect}
                        searchOptions={this.state.searchOptions}>
                        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                            <div onBlur={this.onBlur}>
                                <input {...getInputProps({ className: 'location-search-input', id: this.props.id })} />
                                <div className="autocomplete-dropdown-container">
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active ? 'suggestion-item--active suggestion-item' : 'suggestion-item';

                                        const style = suggestion.active
                                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                        return (
                                            <div key={suggestion.placeId} {...getSuggestionItemProps(suggestion, { className, style })}>
                                                <span>{suggestion.description}</span>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>
                }
            </div>
        );
    }
}

const mapState = (state) => {
    return {
        gmapsLoaded: get(state, "page.gmapsLoaded")
    }
}

const mapDispatch = () => {
    return {
    }
}

const AddressAutocompleteContainer = initPlacesAutocomplete(connect(mapState, mapDispatch)(AddressAutocomplete));
export default AddressAutocompleteContainer;